export const cloudinaryImageGeneration = (src: string) => {
  return `https://res.cloudinary.com/${process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME}/image/upload/t_packshot-big/${src}`
}
